









import { Component, Vue } from 'vue-property-decorator'
import Update from '@/components/Update.vue'
import store from '../store'
import axios from 'axios'
import DisableStore from '@/components/DisableStore.vue'

@Component({
  name: 'Settings',
  components: { Update, DisableStore }
})
export default class extends Vue {
  created() {
    console.log('created')
  }
}
